module.exports = {
      id: "1ae56ee792fd6c4c2b7ac0fe3d8a8d42bathroomEquipment-none.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#1ae56ee792fd6c4c2b7ac0fe3d8a8d42bathroomEquipment-none.svg",
      toString: function () {
        return this.url;
      }
    }